// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PRINTING_DC_REQUEST = 'FETCH_PRINTING_DC_REQUEST';
export const FETCH_PRINTING_DC_SUCCESS = 'FETCH_PRINTING_DC_SUCCESS';
export const FETCH_PRINTING_DC_FAILURE = 'FETCH_PRINTING_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_PRINTING_DC_REQUEST = 'CREATE_PRINTING_DC_REQUEST';
export const CREATE_PRINTING_DC_SUCCESS = 'CREATE_PRINTING_DC_SUCCESS';
export const CREATE_PRINTING_DC_FAILURE = 'CREATE_PRINTING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_PRINTING_DC = 'CREATE_USER_FORM_PRINTING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_PRINTING_DC_REQUEST = 'UPDATE_PRINTING_DC_REQUEST';
export const UPDATE_PRINTING_DC_SUCCESS = 'UPDATE_PRINTING_DC_SUCCESS';
export const UPDATE_PRINTING_DC_FAILURE = 'UPDATE_PRINTING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_PRINTING_DC_REQUEST = 'FETCH_SINGLE_PRINTING_DC_REQUEST';
export const FETCH_SINGLE_PRINTING_DC_SUCCESS = 'FETCH_SINGLE_PRINTING_DC_SUCCESS';
export const FETCH_SINGLE_PRINTING_DC_FAILURE = 'FETCH_SINGLE_PRINTING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_PRINTING_DC_REQUEST = 'DELETE_PRINTING_DC_REQUEST';
export const DELETE_PRINTING_DC_SUCCESS = 'DELETE_PRINTING_DC_SUCCESS';
export const DELETE_PRINTING_DC_FAILURE = 'DELETE_PRINTING_DC_FAILURE';

// USERFORM RESET

export const PRINTING_DC_USERFORM_RESET = 'PRINTING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_PRINTING_DC_DETAILS = 'NAVIGATE_PRINTING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_PRINTING_DC = 'NAVIGATE_PRINTING_DC';
export const PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

export const FETCH_PRINTING_DC_STYLE_REQUEST = 'FETCH_PRINTING_DC_STYLE_REQUEST';
export const FETCH_PRINTING_DC_STYLE_SUCCESS = 'FETCH_PRINTING_DC_STYLE_SUCCESS';
export const FETCH_PRINTING_DC_STYLE_FAILURE = 'FETCH_PRINTING_DC_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_PRINTING_DC_INVOICE_REQUEST = 'FETCH_PRINTING_DC_INVOICE_REQUEST';
export const FETCH_PRINTING_DC_INVOICE_SUCCESS = 'FETCH_PRINTING_DC_INVOICE_SUCCESS';
export const FETCH_PRINTING_DC_INVOICE_FAILURE = 'FETCH_PRINTING_DC_INVOICE_FAILURE';


// FETCH ALL PROPERTIES FROM TEAM MASTER
export const PRINTING_DC_PROGRAM_ID_REQUEST = 'PRINTING_DC_PROGRAM_ID_REQUEST';
export const PRINTING_DC_PROGRAM_ID_SUCCESS = 'PRINTING_DC_PROGRAM_ID_SUCCESS';
export const PRINTING_DC_PROGRAM_ID_FAILURE = 'PRINTING_DC_PROGRAM_ID_FAILURE';

export const RESET_PRINTING_DC_INVOICE = 'RESET_PRINTING_DC_INVOICE';


export const CHECK_ALL_UPDATE_REQUEST_PRINTING_DC = 'CHECK_ALL_UPDATE_REQUEST_PRINTING_DC';
export const CHECK_ALL_UPDATE_SUCCESS_PRINTING_DC = 'CHECK_ALL_UPDATE_SUCCESS_PRINTING_DC';
export const CHECK_ALL_UPDATE_FAILURE_PRINTING_DC = 'CHECK_ALL_UPDATE_FAILURE_PRINTING_DC';

export const CLOSE_BTN_POST_REQUEST_PRINTING_DC = 'CLOSE_BTN_POST_REQUEST_PRINTING_DC';
export const CLOSE_BTN_POST_SUCCESS_PRINTING_DC = 'CLOSE_BTN_POST_SUCCESS_PRINTING_DC';
export const CLOSE_BTN_POST_FAILURE_PRINTING_DC = 'CLOSE_BTN_POST_FAILURE_PRINTING_DC';

export const DELETE_PRINTING_DC_REQUEST_CALL_OFF = ' DELETE_PRINTING_DC_REQUEST_CALL_OFF';
export const DELETE_PRINTING_DC_SUCCESS_CALL_OFF = ' DELETE_PRINTING_DC_SUCCESS_CALL_OFF';
export const DELETE_PRINTING_DC_FAILURE_CALL_OFF = ' DELETE_PRINTING_DC_FAILURE_CALL_OFF';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_PRINTING_DC_DETAILS_PRINT = 'NAVIGATE_PRINTING_DC_DETAILS_PRINT';


export const PRINTING_PROCESS_PROGRAM_REQUEST = 'PRINTING_PROCESS_PROGRAM_REQUEST'
export const PRINTING_PROCESS_PROGRAM_SUCCESS = 'PRINTING_PROCESS_PROGRAM_SUCCESS'
export const PRINTING_PROCESS_PROGRAM_FALIURE = 'PRINTING_PROCESS_PROGRAM_FALIURE'
